export var TelemetryEvents;
(function (TelemetryEvents) {
    // App
    TelemetryEvents["SessionStarted"] = "SessionStarted";
    // User
    TelemetryEvents["UserLogInRequested"] = "UserLogInRequested";
    TelemetryEvents["UserLoginFailed"] = "UserLoginFailed";
    TelemetryEvents["UserLogOutRequested"] = "UserLogOutRequested";
    TelemetryEvents["UserLogOutFailed"] = "UserLogOutFailed";
    TelemetryEvents["AcquireTokenFailed"] = "AcquireTokenFailed";
    // Routes
    TelemetryEvents["PageEnter"] = "PageEnter";
    TelemetryEvents["PageLeave"] = "PageLeave";
    // Side nav
    TelemetryEvents["NavLinkClicked"] = "NavLinkClicked";
    // Header
    TelemetryEvents["HeaderAppNameLinkClicked"] = "HeaderAppNameLinkClicked";
    TelemetryEvents["HeaderSearchRequested"] = "HeaderSearchRequested";
    TelemetryEvents["HeaderPanelOpened"] = "HeaderPanelOpened";
    TelemetryEvents["HeaderPanelClosed"] = "HeaderPanelClosed";
    TelemetryEvents["InvalidComponentConfig"] = "InvalidComponentConfig";
    // HTTP
    TelemetryEvents["APIRequestStarted"] = "APIRequestStarted";
    TelemetryEvents["APIResponseReceived"] = "APIResponseReceived";
    TelemetryEvents["APIFailedWithoutResponse"] = "APIFailedWithoutResponse";
    TelemetryEvents["APIFailedResponseReceived"] = "APIFailedResponseReceived";
    // Components
    TelemetryEvents["ButtonClicked"] = "ButtonClicked";
    TelemetryEvents["LinkClicked"] = "LinkCliked";
    TelemetryEvents["FormElementClicked"] = "FormElementClicked";
})(TelemetryEvents || (TelemetryEvents = {}));
//# sourceMappingURL=TelemetryEvents.js.map